import { Operations } from '../material-ui/NavigatorData';
import { CommonAction } from './commonAction';
import { CommonConfig, PatchDirection, CommonDataOrName, CommonRestProperties } from './commonConfig';

export class CreatePatchConfig extends CommonConfig implements PatchRestProperties {
  public patchDirection = PatchDirection.aTob;
  restNames = new PatchRestPropertyNames();

  constructor(aFile: File | any, bFile: File | any) {
    super();
    this.aJSON = CommonAction.convertToBlobIfString(aFile);
    this.bJSON = CommonAction.convertToBlobIfString(bFile);
  }
}

interface PatchDataOrName extends CommonDataOrName {
  patchDirection: PatchDirection | string;
}
  
class PatchRestProperties extends CommonRestProperties implements PatchDataOrName{
  patchDirection!: PatchDirection;
}
  
export class PatchRestPropertyNames implements PatchDataOrName {
  public readonly dxConfiguration =  "dxConfig";
  public readonly patchDirection = "patchDirection";
  public readonly aJSON = "a";
  public readonly bJSON = "b";
  public readonly jobLabel = "jobDescriptor";
  public readonly resultFilename = "resultFilename";
}
  
export class CreatePatchAction extends CommonAction {
  
  constructor(baseURL: string) {
    super(baseURL, "patch", Operations.patch);
  }
    
  public createPatch = this.action;
}